import store from '@/store';
import {requireModule} from '@/routes/guards';

const WorkScheduleIndex = () => import(/* webpackChunkName: "work-schedule-module" */ '@views/schedule/kindergarten/index.vue');
const WorkSchedule = () => import(/* webpackChunkName: "work-schedule-module" */ '@views/schedule/views/WorkScheduleDay.vue');
const WorkScheduleWeekly = () => import(/* webpackChunkName: "work-schedule-module" */ '@views/schedule/views/WorkScheduleWeek.vue');
const WorkScheduleMonthly = () => import(/* webpackChunkName: "work-schedule-module" */ '@views/schedule/views/WorkScheduleMonth.vue');
const WorkScheduleSettingsIndex = () => import(/* webpackChunkName: "work-schedule-module" */ '@views/schedule/kindergarten/settings/index.vue');
const WorkScheduleSettings = () => import(/* webpackChunkName: "work-schedule-module" */ '@views/schedule/kindergarten/settings/views/WorkScheduleSettings.vue');
const WorkScheduleTypes = () => import(/* webpackChunkName: "work-schedule-module" */ '@views/schedule/kindergarten/settings/views/WorkScheduleTypes.vue');
const OrgWorkScheduleIndex = () => import(/* webpackChunkName: "work-schedule-module" */ '@views/schedule/organization/index.vue');
export default [
    {
        path: '/work-schedule',
        components: { base: WorkScheduleIndex },
        beforeEnter: requireModule('work_schedule', (to, from, next) => {
            if(store.getters.canAccessWorkScheduleIndex) {
                next();
            } else {
                next({path: '/access-restricted'});
            }
        }),
        children: [
            {
                path: 'day',
                name: 'workschedule.day',
                components: { workschedule: WorkSchedule }
            },
            {
                path: 'week',
                name: 'workschedule.week',
                components: { workschedule: WorkScheduleWeekly }
            },
            {
                path: 'month',
                name: 'workschedule.month',
                components: { workschedule: WorkScheduleMonthly }
            }
        ]
    },
    {
        path: '/work-schedule/settings',
        components: { base: WorkScheduleSettingsIndex },
        beforeEnter: requireModule('work_schedule', (to, from, next) => {
            if(store.getters.canAccessWorkScheduleSettings) {
                next();
            } else {
                next({path: '/access-restricted'});
            }
        }),
        children: [
            {
                path: '',
                name: 'workschedule.settings',
                components: { 'work-schedule-settings': WorkScheduleSettings }
            },
            {
                path: 'types',
                name: 'workschedule.types',
                components: { 'work-schedule-settings': WorkScheduleTypes }
            }
        ]
    },
    {
        path: '/organization/work-schedule',
        components: { base: OrgWorkScheduleIndex },
        beforeEnter: (to, from, next) => {
            if(store.getters.canAccessOrganizationWorkSchedules) {
                next();
            } else {
                next({path: '/access-restricted'});
            }
        },
        children: [
            {
                path: 'day',
                name: 'organization.work-schedule.day',
                components: { orgWorkSchedule: WorkSchedule }
            },
            {
                path: 'week',
                name: 'organization.work-schedule.week',
                components: { orgWorkSchedule: WorkScheduleWeekly }
            },
            {
                path: 'month',
                name: 'organization.work-schedule.month',
                components: { orgWorkSchedule: WorkScheduleMonthly }
            }
        ]
    }

];
